






















































































































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { ticketClient } from "@/api/index";
import {
  GetTicketEntrustRulesReq,
  SaveTicketEntrustRuleReq,
  DeleteTicketEntrustRuleReq,
  GetTicketAssignParamReq,
  GetLoadAttrsOptionReq,
  GetTicketAttrsOptionReq,
  TicketEntrustRuleAttr,
  GetTicketEntrustParamReq,
} from "@/pbjs/external/ticket/ticket_pb";
import { timeFormat, addZero } from "@/utils/index.ts";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, errorMsg, setPage } from "@/utils/request";
import { arrRemove } from "@/utils/index";

@Component({
  name: "CombinationProperty",
})
export default class CombinationProperty extends Vue {
  @Provide() private token: any;
  @Provide() private userId: number | null = null;
  @Provide() private resultData: any = [];
  @Provide() private sortticketList: any = [];
  @Provide() private loadAttrList: any = [];
  @Provide() private combOptions: any = [];
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private isEditName: boolean = false;
  @Provide() private isEditId: number = 0;
  @Provide() private thirdcompanyList: any = [];
  @Provide() private WorkModeOptions: any = [];
  @Provide() private form: any = {
    moment: null,
    ticketType: null,
    sortTicketValue: null,
    loadValue: null,
    tripartite: null,
    WorkDay: "",
    name: "",
  };
  @Provide() private pagnition: any = pagnition;

  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getTicketEntrustRules();
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getTicketEntrustRules();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getTicketEntrustRules();
  }

  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getTicketEntrustRules();
  }

  private created() {
    this.token = localStorage.getItem("token");
    this.userId = Number(localStorage.getItem("userid"));
    this.getTicketAssignParam();
    this.getLoadAttrsOption();
    this.getTicketAttrsOption();
    this.getTicketEntrustRules();
    this.getTicketEntrustParam();
  }

  private editName() {
    this.isEditName = true;
  }

  private resetForm() {
    this.form = {
      moment: null,
      ticketType: null,
      sortTicketValue: null,
      loadValue: null,
      tripartite: null,
      name: "",
      WorkDay: "",
    };
  }

  private editOutsourceItem(row: any) {
    this.isEditName = true;
    this.isEditId = row.id;
    this.form = {
      moment: this.getTaskTime(row.attrs.tasktime),
      ticketType: row.attrs.ticketattrList,
      sortTicketValue: row.attrs.sortticketList[0],
      loadValue: row.attrs.loadattrList[0],
      tripartite: row.attrs.thirdidList[0],
      WorkDay: row.attrs.workday,
      name: row.attrs.name,
    };
  }

  // 停用、启用
  private stopOrStartAssignRuleAction(id: number, action: number) {
    this.dwAssignRule({
      id: Number(id),
      action: Number(action),
    });
  }
  // 删除
  private deleteAssignRuleAction(id: number) {
    this.dwAssignRule({
      id: Number(id),
      action: 3,
    });
  }
  // 启用停用和删除工用的处理参数、请求的函数
  private async dwAssignRule(options: any) {
    interface IDeleteTicketRecycleRuleReqOptions {
      id: number;
      action: number;
    }
    let _arg: IDeleteTicketRecycleRuleReqOptions = {
      id: Number(options.id),
      action: Number(options.action),
    };
    const { deleteTicketEntrustRule }: any = await import(
      "@/request/deleteTicketEntrustRule"
    );
    let response = await deleteTicketEntrustRule(_arg, this);
    if (response && response.commonout) {
      if (response.commonout.code == 0) {
        this.$message({
          message: "success",
          type: "success",
        });
        if (options.action == 3) {
          let _item = this.resultData.find((item: any) => {
            if (item.id == options.id) {
              return item;
            }
          });
          arrRemove(this.resultData, _item);
        } else {
          this.resultData = this.resultData.map((item: any) => {
            // if(item.id == options.id) {
            // }
            item.attrs.workstatus =
              item.id == options.id
                ? item.attrs.workstatus == 1
                  ? 0
                  : 1
                : item.attrs.workstatus;
            return item;
          });
        }
      } else {
        this.$message({
          message: response.commonout.errmsg,
          type: "error",
        });
      }
    }
  }
  private formatTime(time: Date | null): any {
    if (time) {
      if (typeof time === "number") {
        time = new Date(time);
      }
      return addZero(time.getHours()) + ":" + addZero(time.getMinutes());
    } else {
      return time;
    }
  }

  private getTaskTime(time: string | null) {
    if (time) {
      let timeArr = time.split(":");
      return new Date(2020, 6, 1, Number(timeArr[0]), Number(timeArr[1]));
    } else {
      return null;
    }
  }

  // lin 获取工单分配支持的所有的参数数据
  private async getTicketAssignParam() {
    let _arg: any = {
      systemType: 0,
    };
    const { getTicketAssignParam }: any = await import("@/request/getTicketAssign");
    let res = await getTicketAssignParam(_arg);
    if (res && res.param) {
      this.sortticketList = res.param.sortticketList;
      this.WorkModeOptions = res.param.workmodeList;
      //                 // this.roleGroupNewList = data.param.adminfilterList;
    }
  }
  private async getTicketEntrustParam() {
    const { getTicketEntrustParam }: any = await import(
      "@/request/getTicketEntrustParam"
    );
    let res = await getTicketEntrustParam();
    if (res) {
      this.thirdcompanyList = res.thirdcompanyList;
      //                 // this.roleGroupNewList = data.param.adminfilterList;
    }
  }

  private getLoadAttrsOption() {
    let request: any = new GetLoadAttrsOptionReq();
    request.setCommonin(setCommon());
    ticketClient.getLoadAttrsOption(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (!data.commonout || data.commonout.code == 0) {
          this.loadAttrList = data.listList;
        } else if (data.code == 100100 || data.code == 100101) {
          this.$router.push("./login");
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private getTicketAttrsOption() {
    let request: any = new GetTicketAttrsOptionReq();
    request.setCommonin(setCommon());
    ticketClient.getTicketAttrsOption(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (!data.commonout || data.commonout.code == 0) {
          this.combOptions = data.listList;
        } else if (data.code == 100100 || data.code == 100101) {
          this.$router.push("./login");
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private getTicketEntrustRules() {
    let request: any = new GetTicketEntrustRulesReq();
    request.setCommonin(setCommon());
    request.setPagein(setPage(this.pageIndex, this.pageSize));
    ticketClient.getTicketEntrustRules(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (!data.commonout || data.commonout.code == 0) {
          this.pagerCount = data.pageout.total;
          data.listList.forEach((item: any) => {
            item.newTime = timeFormat(item.ctime);
          });
          this.resultData = data.listList;
        } else if (data.code == 100100 || data.code == 100101) {
          this.$router.push("./login");
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private saveTicketEntrustRule() {
    let request: any = new SaveTicketEntrustRuleReq();
    let saveItem: any = new TicketEntrustRuleAttr();
    saveItem.setTasktime(this.formatTime(this.form.moment));
    saveItem.setTicketattrList(this.form.ticketType);
    saveItem.setSortticketList([this.form.sortTicketValue]);
    saveItem.setLoadattrList([this.form.loadValue]);
    saveItem.setThirdidList([this.form.tripartite]);
    saveItem.setName(this.form.name);
    saveItem.setWorkday(this.form.WorkDay);
    request.setCommonin(setCommon());
    request.setId(this.isEditId);
    request.setData(saveItem);
    // request.setAdminuid(this.userId);
    ticketClient.saveTicketEntrustRule(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (!data.commonout || data.commonout.code == 0) {
          this.getTicketEntrustRules();
          this.resetForm();
          this.isEditName = false;
          this.$message({ type: "success", message: "Sucess" });
        } else if (data.code == 100100 || data.code == 100101) {
          this.$router.push("./login");
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
}
